import React, { useState, useEffect, useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, Cell, LabelList, ResponsiveContainer } from 'recharts';
import { getGPS, getPlayers, getScenarios, getLoadScenarios } from '../../api';
import { useUrlParam } from '../../hooks/useUrlParam';

// ── Targets (same data as GPSData.js) ─────────────────────────────────────────
const TARGETS_RAW = `Scenario\tdaylabel\tpos\tTD Upper\tTD Lower\tRD Upper\tRD Lower\tHID Upper\tHID Lower\tSD Upper\tSD Lower\tSA Upper\tSA Lower\tExpl Upper\tExpl Lower\tHMLD Upper\tHMLD Lower
1A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1B\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1B\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1B\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1B\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1B\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1B\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1B\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1B\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1B\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1B\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1B\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1B\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1B\tMD+4\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1B\tMD+4\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1B\tMD+4\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1B\tMD+4\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1B\tMD+4\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1B\tMD+4\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1B\tMD-3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1B\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
1B\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
1B\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
1B\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
1B\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
1B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
1B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1C\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1C\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1C\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1C\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1C\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1C\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1C\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1C\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1C\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1C\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1C\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1C\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1C\tMD+4\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD-3\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
1C\tMD-3\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
1C\tMD-3\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
1C\tMD-3\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
1C\tMD-3\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
1C\tMD-3\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
1C\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1C\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
1C\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
1C\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
1C\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
1C\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
1C\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
1C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1D\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1D\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1D\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1D\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1D\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1D\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1D\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1D\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1D\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1D\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1D\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1D\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1D\tMD+4\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1D\tMD+4\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1D\tMD+4\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1D\tMD+4\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1D\tMD+4\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1D\tMD+4\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1D\tMD-4\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-3\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
1D\tMD-3\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
1D\tMD-3\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
1D\tMD-3\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
1D\tMD-3\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
1D\tMD-3\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
1D\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1D\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
1D\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
1D\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
1D\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
1D\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
1D\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
1D\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1D\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1D\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1D\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1D\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1D\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1D\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1D\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1D\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1D\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1D\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1E\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1E\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1E\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1E\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1E\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1E\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1E\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1E\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1E\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1E\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1E\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1E\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1E\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1E\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1E\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1E\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1E\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1E\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1E\tMD-2\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
1E\tMD-2\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
1E\tMD-2\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
1E\tMD-2\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
1E\tMD-2\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
1E\tMD-2\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
1E\tMD-1\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1E\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1E\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1E\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1E\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1E\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1E\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1E\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1E\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1E\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1E\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1E\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
2A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
2A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
2A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
2A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
2A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
2A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
2A\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
2A\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
2A\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
2A\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
2A\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
2A\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
2A\tMD-3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
2A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
2A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
2A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
2A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
2A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
2A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
2A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
2A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
2A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
2A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
2A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
2A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
2A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
2A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
2A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
2A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
2A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
2B\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
2B\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
2B\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
2B\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
2B\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
2B\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
2B\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
2B\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
2B\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
2B\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
2B\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
2B\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
2B\tMD-3\tCB\t7304\t6034\t1613\t1233\t429\t295\t87\t32\t126\t104\t816\t583\t1465\t1033
2B\tMD-3\tFB\t7638\t6310\t1557\t1191\t749\t515\t183\t68\t161\t133\t1040\t743\t2105\t1480
2B\tMD-3\tCDM\t8388\t6929\t1910\t1460\t601\t413\t90\t33\t152\t125\t982\t701\t1862\t1311
2B\tMD-3\tCAM\t8069\t6666\t2152\t1646\t578\t397\t85\t32\t152\t125\t982\t701\t1835\t1293
2B\tMD-3\tST\t7344\t6067\t1718\t1314\t679\t467\t143\t53\t138\t114\t894\t638\t1850\t1300
2B\tMD-3\tW\t4845\t4003\t1575\t1204\t743\t511\t154\t57\t161\t133\t1040\t743\t2099\t1476
2B\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
2B\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
2B\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
2B\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
2B\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
2B\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
2B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
2B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
2B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
2B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
2B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
2B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
2B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
2B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
2B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
2B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
2B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
2B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
2C\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
2C\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
2C\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
2C\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
2C\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
2C\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
2C\tMD-3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
2C\tMD-3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
2C\tMD-3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
2C\tMD-3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
2C\tMD-3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
2C\tMD-3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
2C\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
2C\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
2C\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
2C\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
2C\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
2C\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
2C\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
2C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
2C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
2C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
2C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
2C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
2C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
2C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
2C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
2C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
2C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
2C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3A\tMD+3\tCB\t7304\t6034\t1613\t1233\t429\t295\t87\t32\t126\t104\t816\t583\t1465\t1033
3A\tMD+3\tFB\t7638\t6310\t1557\t1191\t749\t515\t183\t68\t161\t133\t1040\t743\t2105\t1480
3A\tMD+3\tCDM\t8388\t6929\t1910\t1460\t601\t413\t90\t33\t152\t125\t982\t701\t1862\t1311
3A\tMD+3\tCAM\t8069\t6666\t2152\t1646\t578\t397\t85\t32\t152\t125\t982\t701\t1835\t1293
3A\tMD+3\tST\t7344\t6067\t1718\t1314\t679\t467\t143\t53\t138\t114\t894\t638\t1850\t1300
3A\tMD+3\tW\t4845\t4003\t1575\t1204\t743\t511\t154\t57\t161\t133\t1040\t743\t2099\t1476
3A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
3A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
3A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
3A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
3A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
3A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
3A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3B\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3B\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3B\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3B\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3B\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3B\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3B\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3B\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3B\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3B\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3B\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3B\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3B\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3B\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
3B\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
3B\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
3B\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
3B\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
3B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
3B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3C\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3C\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3C\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3C\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3C\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3C\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3C\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3C\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3C\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3C\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3C\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3C\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3C\tMD+3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3C\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
3C\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
3C\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
3C\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
3C\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
3C\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
3C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3D\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3D\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3D\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3D\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3D\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3D\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3D\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3D\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3D\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3D\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3D\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3D\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3D\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3D\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3D\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3D\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3D\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3D\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3D\tMD-2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-1\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3D\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3D\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3D\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3D\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3D\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3D\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3D\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3D\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3D\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3D\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3D\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
4A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
4A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
4A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
4A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
4A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
4A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
4A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
4A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
4A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
4A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
4A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
4A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
4A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
4A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
4A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
4A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
4A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
4A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
4A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
4A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
4A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
4A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
4A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
4A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
4B\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
4B\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
4B\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
4B\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
4B\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
4B\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
4B\tMD+3\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
4B\tMD+3\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
4B\tMD+3\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
4B\tMD+3\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
4B\tMD+3\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
4B\tMD+3\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
4B\tMD+4\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
4B\tMD+4\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
4B\tMD+4\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
4B\tMD+4\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
4B\tMD+4\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
4B\tMD+4\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
4B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
4B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
4B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
4B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
4B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
4B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
4C\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
4C\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
4C\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
4C\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
4C\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
4C\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
4C\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD-2\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
4C\tMD-2\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
4C\tMD-2\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
4C\tMD-2\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
4C\tMD-2\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
4C\tMD-2\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
4C\tMD-1\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
4C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
4C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
4C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
4C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
4C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
4C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
4C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
4C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
4C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
4C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
4C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
5A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t652\t475
5A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t831\t606
5A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t784\t572
5A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t618\t442\t724\t529
5A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t714\t521
5A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t831\t606
5A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
5A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
5A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
5A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
5A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
5A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
5A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
5A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
5A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
5A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
5A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
5A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
6A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
6A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
6A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
6A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
6A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
6A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
6A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
6A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
6A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
6A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
6A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
6A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
6A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
6A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
6A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
6A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
6A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
6A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
6B\tMD+1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t118\t97\t564\t403\t612\t436
6B\tMD+1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t150\t124\t720\t514\t802\t571
6B\tMD+1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t142\t117\t679\t485\t746\t531
6B\tMD+1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t142\t117\t679\t485\t743\t529
6B\tMD+1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t129\t107\t618\t442\t693\t493
6B\tMD+1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t150\t124\t720\t514\t802\t571
6B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
6B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
6B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
6B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
6B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
6B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
6B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
6B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
6B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
6B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
6B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
6B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535`;
const parseTargets = () => {
  const lines = TARGETS_RAW.trim().split('\n').slice(1);
  const lookup = {};
  lines.forEach(line => {
    const p = line.split('\t');
    const [scenario, daylabel, pos] = p;
    const n = v => parseFloat(String(v).replace(',', '.')) || 0;
    if (!lookup[scenario]) lookup[scenario] = {};
    if (!lookup[scenario][daylabel]) lookup[scenario][daylabel] = {};
    lookup[scenario][daylabel][pos] = {
      TD:   { upper: n(p[3]),  lower: n(p[4])  },
      RD:   { upper: n(p[5]),  lower: n(p[6])  },
      HID:  { upper: n(p[7]),  lower: n(p[8])  },
      SD:   { upper: n(p[9]),  lower: n(p[10]) },
      SA:   { upper: n(p[11]), lower: n(p[12]) },
      Expl: { upper: n(p[13]), lower: n(p[14]) },
      HMLD: { upper: n(p[15]), lower: n(p[16]) },
    };
  });
  return lookup;
};

const TARGETS = parseTargets();

const METRICS = [
  { key: 'td',   tKey: 'TD',   label: 'Total Distance',      unit: 'm', category: 'Endurance'     },
  { key: 'rd',   tKey: 'RD',   label: 'Run Dist. >14.4km/h', unit: 'm', category: 'Endurance'     },
  { key: 'hid',  tKey: 'HID',  label: 'HID >19.8km/h',       unit: 'm', category: 'High velocity' },
  { key: 'sd',   tKey: 'SD',   label: 'Sprint >25.2km/h',    unit: 'm', category: 'High velocity' },
  { key: 'sa',   tKey: 'SA',   label: 'Short Actions',       unit: '',  category: 'Small spaces'  },
  { key: 'expl', tKey: 'Expl', label: 'Explosive Dist.',     unit: 'm', category: 'Small spaces'  },
  { key: 'hmld', tKey: 'HMLD', label: 'HMLD',                unit: 'm', category: 'High velocity' },
];

const COLORS = { above: '#7c3aed', green: '#10b981', amber: '#f59e0b', below: '#ef4444', none: 'var(--text-dimmed)' };

const fmtDate = d => { if (!d) return '—'; const [y,m,day]=d.split('-'); return `${day}/${m}/${y}`; };

function getStatus(val, t) {
  if (!t || (t.upper === 0 && t.lower === 0)) return 'none';
  if (val > t.upper) return 'above';
  if (val >= t.lower) return 'green';
  if (val >= t.lower * 0.9) return 'amber';
  return 'below';
}

function getDeviation(actual, lower, upper) {
  if (lower === 0 && upper === 0) return null;
  if (actual >= lower && actual <= upper) return 0;
  if (actual < lower) return lower > 0 ? ((actual - lower) / lower) * 100 : null;
  return upper > 0 ? ((actual - upper) / upper) * 100 : null;
}

function deviationColor(dev) {
  if (dev === null) return COLORS.none;
  if (dev > 0)  return COLORS.above;
  if (dev === 0) return COLORS.green;
  if (dev >= -10) return COLORS.amber;
  return COLORS.below;
}

function getISOWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
}

function getISOWeekYear(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  return d.getUTCFullYear();
}

function toISOWeekStr(date) {
  const w = getISOWeek(date);
  const y = getISOWeekYear(date);
  return `${y}-W${String(w).padStart(2, '0')}`;
}

function parseISOWeekToMonday(weekStr) {
  const [yearStr, weekPart] = weekStr.split('-W');
  const year = parseInt(yearStr);
  const week = parseInt(weekPart);
  const jan4 = new Date(Date.UTC(year, 0, 4));
  const dow = jan4.getUTCDay() || 7;
  return new Date(Date.UTC(year, 0, 4 - dow + 1 + (week - 1) * 7));
}

function getWeekRange(weekStr) {
  const mon = parseISOWeekToMonday(weekStr);
  const sun = new Date(mon);
  sun.setUTCDate(mon.getUTCDate() + 6);
  return { start: mon.toISOString().slice(0, 10), end: sun.toISOString().slice(0, 10) };
}

function buildWeekOptions() {
  const seen = new Set(); const opts = [];
  const today = new Date();
  for (let i = 8; i >= -52; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() + i * 7);
    const s = toISOWeekStr(d);
    if (!seen.has(s)) { seen.add(s); opts.push(s); }
  }
  return opts;
}
const WEEK_OPTIONS = buildWeekOptions();

// ── Gauge (same arc logic as GPSData.js) ──────────────────────────────────────
function Gauge({ label, value, targets, category }) {
  const v = value ?? 0;
  const status = getStatus(v, targets);
  const color  = COLORS[status];
  const mid    = targets && targets.upper > 0 ? (targets.upper + targets.lower) / 2 || targets.upper : null;
  const pct    = mid ? Math.round((v / mid) * 100) : null;
  const R = 52; const cx = 70; const cy = 70;
  const startDeg = -200; const sweepDeg = 220;
  const arcPath = f => {
    const c = Math.min(Math.max(f, 0), 1);
    const endDeg = startDeg + sweepDeg * c;
    const toR = d => (d * Math.PI) / 180;
    const x1 = cx + R * Math.cos(toR(startDeg)); const y1 = cy + R * Math.sin(toR(startDeg));
    const x2 = cx + R * Math.cos(toR(endDeg));   const y2 = cy + R * Math.sin(toR(endDeg));
    return `M ${x1} ${y1} A ${R} ${R} 0 ${sweepDeg * c > 180 ? 1 : 0} 1 ${x2} ${y2}`;
  };
  const fill   = targets && targets.upper > 0 ? Math.min(v / targets.upper, 1.15) : 0;
  const lowerF = targets && targets.upper > 0 ? targets.lower / targets.upper : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: 120 }}>
      <svg width="140" height="105" viewBox="0 0 140 105" style={{ overflow: 'visible' }}>
        <path d={arcPath(1)} fill="none" stroke="var(--gauge-track)" strokeWidth="9" strokeLinecap="round" />
        {lowerF != null && (
          <path d={arcPath(lowerF)} fill="none"
            stroke={status === 'none' ? 'var(--gauge-track)' : color}
            strokeWidth="9" strokeLinecap="round" strokeOpacity="0.25" />
        )}
        <path d={arcPath(Math.min(fill, 1))} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round" />
        {fill > 1 && (
          <path d={arcPath(fill)} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round" strokeOpacity="0.4" />
        )}
        <text x="70" y="66" textAnchor="middle" fill={color} fontSize="17" fontWeight="700" fontFamily="Inter, sans-serif">
          {v > 0 ? Math.round(v).toLocaleString() : '—'}
        </text>
        {pct != null && (
          <text x="70" y="81" textAnchor="middle" fill="var(--text-muted)" fontSize="10" fontFamily="Inter, sans-serif">{pct}%</text>
        )}
      </svg>
      <div style={{ textAlign: 'center', marginTop: -8 }}>
        <div style={{ fontSize: '0.73rem', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>{label}</div>
        {targets && targets.upper > 0 ? (
          <div style={{ fontSize: '0.65rem', color: 'var(--text-dimmed)', marginTop: 1 }}>
            {Math.round(targets.lower).toLocaleString()}–{Math.round(targets.upper).toLocaleString()}
          </div>
        ) : (
          <div style={{ fontSize: '0.65rem', color: 'var(--text-dimmed)', marginTop: 1 }}>no target</div>
        )}
      </div>
    </div>
  );
}

// ── Custom bar chart X-axis tick: title on top line, date below ───────────────
function BarXTick({ x, y, payload }) {
  const [title, date] = (payload?.value || '').split('\n');
  return (
    <g transform={`translate(${x},${y + 6})`}>
      <text textAnchor="middle" fill="var(--text-secondary)" fontSize={10} fontFamily="Inter, sans-serif" dy={0}>{title}</text>
      <text textAnchor="middle" fill="var(--text-dimmed)"   fontSize={9}  fontFamily="Inter, sans-serif" dy={13}>{date}</text>
    </g>
  );
}

// ── Main component ─────────────────────────────────────────────────────────────
export default function IndividualTargets({ playerOverride = null }) {
  const [players, setPlayers]           = useState([]);
  const [sessions, setSessions]         = useState([]);
  const [scenarios, setScenarios]       = useState([]);
  const [customTemplates, setCustomTemplates] = useState([]);
  const [playerId, setPlayerId]   = useUrlParam('player_id', playerOverride ? String(playerOverride.id) : '');
  const [isoWeek, setIsoWeek]     = useUrlParam('iso_week', toISOWeekStr(new Date()));
  const [drillTitle, setDrillTitle] = useState('Entire Session - Live');
  const [chartMetric, setChartMetric] = useState('td');
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    Promise.all([getGPS(), getPlayers(), getScenarios(), getLoadScenarios()])
      .then(([gps, pl, sc, ct]) => {
        setSessions(gps || []);
        setScenarios(sc || []);
        setCustomTemplates(ct || []);
        const sorted = (pl || [])
          .filter(p => p.active !== false)
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        setPlayers(sorted);
        if (playerOverride) setPlayerId(String(playerOverride.id));
        else if (sorted.length) setPlayerId(String(sorted[0].id));
      })
      .finally(() => setLoading(false));
  }, [playerOverride]);

  const { start: weekStart, end: weekEnd } = useMemo(() => getWeekRange(isoWeek), [isoWeek]);

  // Merge built-in targets with custom template targets so custom scenarios show up
  const allTargets = useMemo(() => {
    const custom = {};
    customTemplates.forEach(t => { if (t.name && t.targets) custom[t.name] = t.targets; });
    return { ...TARGETS, ...custom };
  }, [customTemplates]);

  const playerWeekSessions = useMemo(() => {
    if (!playerId) return [];
    return sessions
      .filter(s => {
        const d = (s.session_date || '').slice(0, 10);
        return d >= weekStart && d <= weekEnd;
      })
      .flatMap(s => {
        const pd = (s.players || []).find(p => String(p.player_id) === playerId);
        if (!pd) return [];
        const n = v => parseFloat(v) || 0;
        const teamPlayers = (s.players || []).filter(p => p.td != null);
        const avg = key => teamPlayers.length > 0
          ? teamPlayers.reduce((sum, p) => sum + (parseFloat(p[key]) || 0), 0) / teamPlayers.length
          : 0;
        const scenario = s.scenario || '';
        const mdLabel   = pd.md_label || '';
        const position  = pd.position || '';
        const sessionDate = (s.session_date || '').slice(0, 10);
        // A manual day-specific override (set when planning the scenario) takes
        // full precedence over the built-in TARGETS table — same lookup as
        // GPSData.js, otherwise custom scenarios with no TARGETS entry (e.g.
        // pre-season blocks) show no targets at all here.
        const assignment  = scenarios.find(sc => sc.scenario === scenario);
        const dayOverride = assignment?.target_overrides?.[sessionDate]?.[position];
        const rawTargets  = scenario && mdLabel && position ? allTargets[scenario]?.[mdLabel]?.[position] : null;
        const targets     = dayOverride || rawTargets || null;
        return [{
          sessionId: s.id,
          date: sessionDate,
          title:    s.session_title || '',
          scenario, mdLabel, position, targets,
          td: n(pd.td), rd: n(pd.rd), hid: n(pd.hid),
          sd: n(pd.sd), sa: n(pd.sa), expl: n(pd.expl), hmld: n(pd.hmld),
          teamAvg: { td: avg('td'), rd: avg('rd'), hid: avg('hid'), sd: avg('sd'), sa: avg('sa'), expl: avg('expl'), hmld: avg('hmld') },
        }];
      })
      .sort((a, b) => a.date.localeCompare(b.date));
  }, [sessions, playerId, weekStart, weekEnd, scenarios, allTargets]);

  // Cumulative totals: sum actuals + sum each session's day-target across all week sessions
  const cumulative = useMemo(() => {
    if (!playerWeekSessions.length) return null;
    const actual = {}, tgtLower = {}, tgtUpper = {}, teamAvgSum = {};
    METRICS.forEach(m => { actual[m.key] = 0; tgtLower[m.key] = 0; tgtUpper[m.key] = 0; teamAvgSum[m.key] = 0; });
    playerWeekSessions.forEach(s => {
      const tgt = s.targets;
      METRICS.forEach(m => {
        actual[m.key]      += s[m.key] || 0;
        teamAvgSum[m.key]  += s.teamAvg?.[m.key] || 0;
        if (tgt?.[m.tKey]) { tgtLower[m.key] += tgt[m.tKey].lower; tgtUpper[m.key] += tgt[m.tKey].upper; }
      });
    });
    const targets = {};
    METRICS.forEach(m => { targets[m.tKey] = { lower: tgtLower[m.key], upper: tgtUpper[m.key] }; });
    const first = playerWeekSessions[0];
    const last  = playerWeekSessions[playerWeekSessions.length - 1];
    return { actual, targets, teamAvg: teamAvgSum, scenario: first.scenario, position: first.position,
      dateRange: `${fmtDate(first.date)} – ${fmtDate(last.date)}`, sessionCount: playerWeekSessions.length };
  }, [playerWeekSessions]);

  // Per-session bar chart: each bar = that day's actual vs that day's individual target
  const chartData = useMemo(() => {
    const m = METRICS.find(x => x.key === chartMetric);
    if (!m) return [];
    return playerWeekSessions.map(s => {
      const tgt = s.targets?.[m.tKey];
      const dev = tgt ? getDeviation(s[m.key], tgt.lower, tgt.upper) : null;
      const shortDate = s.date ? `${s.date.slice(8)}-${s.date.slice(5,7)}` : '';
      return { label: `${s.title || s.mdLabel}\n${shortDate}`, dev, color: deviationColor(dev) };
    });
  }, [playerWeekSessions, chartMetric]);

  // Remaining = cumulative lower target minus cumulative actual (floored at 0)
  const remainingLoad = useMemo(() => {
    if (!cumulative) return [];
    return METRICS.map(m => {
      const t   = cumulative.targets[m.tKey];
      const val = cumulative.actual[m.key];
      if (!t || t.lower === 0) return { ...m, remaining: null, done: false };
      const rem = Math.max(0, t.lower - val);
      return { ...m, remaining: rem, done: rem === 0 };
    });
  }, [cumulative]);

  const player = useMemo(() => players.find(p => String(p.id) === playerId), [players, playerId]);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: 'var(--text-muted)', fontSize: '0.9rem' }}>Loading…</div>
  );

  const hasData = playerWeekSessions.length > 0;
  const weekNum = isoWeek.split('-W')[1];

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', paddingBottom: 40 }}>

      {/* ── Header ── */}
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: 'var(--text-primary)', margin: 0 }}>Individual Target Analysis</h2>
        <p style={{ fontSize: '0.83rem', color: 'var(--text-muted)', margin: '4px 0 0' }}>Weekly performance vs. individual session targets</p>
      </div>

      {/* ── Filters ── */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 24, flexWrap: 'wrap' }}>
        {!playerOverride && (
          <select value={playerId} onChange={e => setPlayerId(e.target.value)} style={SEL}>
            {players.map(p => <option key={p.id} value={String(p.id)}>{p.name || p.username || `Player ${p.id}`}</option>)}
          </select>
        )}
        <select value={isoWeek} onChange={e => setIsoWeek(e.target.value)} style={SEL}>
          {WEEK_OPTIONS.map(w => <option key={w} value={w}>{w.replace('-W', ' · W')}</option>)}
        </select>
        <select value={drillTitle} onChange={e => setDrillTitle(e.target.value)} style={SEL}>
          <option value="Entire Session - Live">Entire Session - Live</option>
        </select>
      </div>

      {/* ── Empty state ── */}
      {!hasData && (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 320, color: 'var(--text-muted)', textAlign: 'center', gap: 12 }}>
          <svg width="44" height="44" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.2} opacity={0.4}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <p style={{ margin: 0, fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
            No sessions found for this player in week {weekNum}.
          </p>
        </div>
      )}

      {hasData && cumulative && (
        <>
          {/* ── Week summary label ── */}
          <div style={{ marginBottom: 16, padding: '8px 14px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 9, display: 'inline-flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>Cumulative week total:</span>
            <span style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-secondary)' }}>
              {cumulative.sessionCount} session{cumulative.sessionCount !== 1 ? 's' : ''} · {cumulative.dateRange}
            </span>
            <span style={{ fontSize: '0.75rem', color: 'var(--text-dimmed)' }}>
              {player?.position || cumulative.position} · Scenario {cumulative.scenario}
            </span>
          </div>

          {/* ── Section 1: Gauges (cumulative actual vs cumulative target) ── */}
          <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 14, padding: '18px 20px', marginBottom: 20 }}>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'nowrap', overflowX: 'auto' }}>
              {METRICS.map(m => (
                <Gauge key={m.key} label={m.label} value={cumulative.actual[m.key]} targets={cumulative.targets[m.tKey]} category={m.category} />
              ))}
            </div>
          </div>

          {/* ── Sections 2 + 3: Chart + Table ── */}
          <div style={{ display: 'flex', gap: 16, marginBottom: 20, alignItems: 'flex-start', flexWrap: 'wrap' }}>

            {/* Section 2: Deviation bar chart */}
            <div style={{ flex: '2 1 360px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 14, padding: '18px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, gap: 12, flexWrap: 'wrap' }}>
                <div>
                  <span style={{ fontSize: '0.86rem', fontWeight: 700, color: 'var(--text-primary)' }}>Daily Deviation</span>
                  <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginLeft: 8 }}>per session vs daily target</span>
                </div>
                <select value={chartMetric} onChange={e => setChartMetric(e.target.value)}
                  style={{ ...SEL, minWidth: 0, padding: '4px 28px 4px 10px', fontSize: '0.78rem' }}>
                  {METRICS.map(m => <option key={m.key} value={m.key}>{m.label}</option>)}
                </select>
              </div>
              {chartData.length > 0 ? (
                <ResponsiveContainer width="100%" height={240}>
                  <BarChart data={chartData} margin={{ top: 22, right: 12, left: -8, bottom: 36 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
                    <XAxis dataKey="label" tick={<BarXTick />} axisLine={false} tickLine={false} interval={0} height={44} />
                    <YAxis tick={{ fill: 'var(--text-muted)', fontSize: 10, fontFamily: 'Inter, sans-serif' }}
                      axisLine={false} tickLine={false} tickFormatter={v => `${v > 0 ? '+' : ''}${v.toFixed(0)}%`} />
                    <ReferenceLine y={0} stroke="var(--border-strong)" strokeWidth={1.5} />
                    <Tooltip
                      contentStyle={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8, fontSize: 12 }}
                      labelStyle={{ color: 'var(--text-primary)', fontWeight: 600 }}
                      formatter={v => [v != null ? `${v > 0 ? '+' : ''}${v.toFixed(1)}%` : '—', 'Deviation']}
                    />
                    <Bar dataKey="dev" radius={[3, 3, 0, 0]} maxBarSize={52}>
                      {chartData.map((e, i) => <Cell key={i} fill={e.color} />)}
                      <LabelList dataKey="dev" content={({ x, y, width, value, height }) => {
                        if (value == null) return null;
                        const lbl = `${value > 0 ? '+' : ''}${value.toFixed(1)}%`;
                        const above = value >= 0;
                        const h = Math.abs(height || 0);
                        return (
                          <text x={x + width / 2} y={above ? y - 4 : y + h + 11}
                            textAnchor="middle" fill="var(--text-secondary)" fontSize={10} fontWeight="600"
                            fontFamily="Inter, sans-serif">{lbl}</text>
                        );
                      }} />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              ) : (
                <div style={{ height: 230, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-dimmed)', fontSize: '0.83rem' }}>
                  No target data for this metric
                </div>
              )}
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 10, fontSize: '0.71rem', color: 'var(--text-muted)' }}>
                {[['#10b981','On target'],['#f59e0b','Near (0–10% below)'],['#ef4444','Too low (>10% below)'],['#7c3aed','Overloaded']].map(([c,l]) => (
                  <span key={l} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ width: 8, height: 8, borderRadius: 2, background: c, display: 'inline-block', flexShrink: 0 }} />{l}
                  </span>
                ))}
              </div>
            </div>

            {/* Section 3: Target table */}
            <div style={{ flex: '1 1 280px', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 14, padding: '18px 20px' }}>
              <div style={{ fontSize: '0.86rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 14 }}>Cumulative Week Total</div>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {['Metric','Target','Team Avg','Actual',''].map(h => (
                      <th key={h} style={TH}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {METRICS.map((m, i) => {
                    const t    = cumulative.targets[m.tKey];
                    const val  = cumulative.actual[m.key];
                    const avg  = cumulative.teamAvg?.[m.key];
                    const status = getStatus(val, t);
                    const col  = COLORS[status];
                    const hasTgt = t && (t.upper > 0 || t.lower > 0);
                    const icon = status === 'above' ? '↑' : status === 'green' ? '✓' : status === 'amber' ? '↓' : status === 'below' ? '↓' : '—';
                    const iconCol = status === 'above' ? COLORS.above : status === 'green' ? COLORS.green : status === 'amber' ? COLORS.amber : status === 'below' ? COLORS.below : 'var(--text-dimmed)';
                    return (
                      <tr key={m.key} style={{ background: i % 2 !== 0 ? 'var(--bg-row-alt)' : 'transparent' }}>
                        <td style={{ ...TD, fontSize: '0.75rem' }}>{m.label}</td>
                        <td style={{ ...TD, color: 'var(--text-muted)', fontSize: '0.74rem' }}>
                          {hasTgt ? `${Math.round(t.lower).toLocaleString()}–${Math.round(t.upper).toLocaleString()}` : '—'}
                        </td>
                        <td style={{ ...TD, color: 'var(--text-muted)', fontSize: '0.78rem' }}>
                          {avg != null ? Math.round(avg).toLocaleString() : '—'}
                        </td>
                        <td style={{ ...TD, fontWeight: 600, color: col }}>{Math.round(val).toLocaleString()}</td>
                        <td style={{ ...TD, textAlign: 'center', fontWeight: 700, color: iconCol, fontSize: '0.9rem' }}>{icon}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── Section 4: Remaining load ── */}
          <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 14, padding: '18px 20px' }}>
            <div style={{ fontSize: '0.86rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 14 }}>Remaining Load Needed</div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['Metric','Lower Target','Actual','Remaining','Status'].map(h => (
                    <th key={h} style={TH}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {remainingLoad.map((m, i) => {
                  const t   = cumulative.targets[m.tKey];
                  const val = cumulative.actual[m.key];
                  return (
                    <tr key={m.key} style={{ background: i % 2 !== 0 ? 'var(--bg-row-alt)' : 'transparent' }}>
                      <td style={TD}>{m.label}</td>
                      <td style={{ ...TD, color: 'var(--text-muted)' }}>
                        {t && t.lower > 0 ? Math.round(t.lower).toLocaleString() : '—'}
                      </td>
                      <td style={{ ...TD, fontWeight: 600 }}>{Math.round(val).toLocaleString()}</td>
                      <td style={{ ...TD, fontWeight: 600 }}>
                        {m.remaining === null ? '—' : m.done ? '—' : Math.round(m.remaining).toLocaleString()}
                      </td>
                      <td style={TD}>
                        {m.remaining === null ? (
                          <span style={{ color: 'var(--text-dimmed)' }}>—</span>
                        ) : m.done ? (
                          <span style={{ color: '#10b981', fontWeight: 700, fontSize: '0.82rem' }}>✓ Done</span>
                        ) : (
                          <span style={{ color: '#ef4444', fontSize: '0.78rem' }}>+{Math.round(m.remaining).toLocaleString()} needed</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

// ── Shared styles ──────────────────────────────────────────────────────────────
const SEL = {
  padding: '8px 32px 8px 12px', borderRadius: 8, border: '1px solid var(--border-strong)',
  background: 'var(--bg-card)', color: 'var(--text-primary)', fontSize: '0.88rem',
  fontFamily: 'inherit', cursor: 'pointer', outline: 'none', minWidth: 190,
  appearance: 'none', WebkitAppearance: 'none',
};
const TH = {
  padding: '8px 10px', fontSize: '0.67rem', fontWeight: 600, letterSpacing: '0.08em',
  textTransform: 'uppercase', color: 'var(--text-muted)', textAlign: 'left',
  borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap',
};
const TD = {
  padding: '8px 10px', fontSize: '0.82rem', color: 'var(--text-primary)',
  borderBottom: '1px solid var(--border)',
};
